// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pSr-r","questions":"styles_questions__DKpwM","footer":"styles_footer__33F0y"};